module.exports = __webpack_public_path__ + "img/twitter.492393ae.svg";